export default __webpack_public_path__ + "static/media/car.a4b62b1f.svg";